/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ProductApiConfiguration as __Configuration } from '../product-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ApiService extends __BaseService {
  static readonly getProductsPath = '/api/v1/product';
  static readonly getProductPath = '/api/v1/product/{id}';
  static readonly getExportListPath = '/api/v1/exportlist';
  static readonly getFiltersPath = '/api/v1/filterlist';
  static readonly getBrandsPath = '/api/v1/brandlist';
  static readonly getPerfPath = '/perf';
  static readonly getHeartbeatPath = '/heartbeat';
  static readonly aboutPath = '/about';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * # Product service
   * Returns a list of products.
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only products the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   *
   * (Note: pageno and pagesize are required)
   * @param params The `ApiService.GetProductsParams` containing the following parameters:
   *
   * - `pagesize`: Number of products to return per page
   *
   * - `pageno`: Page number in a paged result set - pageno starts at 1
   *
   * - `upcid`: Optional filter by UPC - supports partial matches
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `skuid`: Optional filter by SKU ID (Full SKU) - supports partial matches
   *
   * - `sizeid`: Optional filter by size ID
   *
   * - `flavorid`: Optional filter by flavor ID
   *
   * - `distskuid`: Optional filter by distributor SKU ID - supports partial matches
   *
   * - `dist`: Distributor billTo id
   *
   * - `destination`: Optional filter by destination DOMESTIC or INTERNATIONAL
   *
   * - `brandid`: Optional filter by brand ID
   *
   * - `appellationid`: Optional filter by appellation ID
   */
  getProductsResponse(params: ApiService.GetProductsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pagesize != null) __params = __params.set('pagesize', params.pagesize.toString());
    if (params.pageno != null) __params = __params.set('pageno', params.pageno.toString());
    if (params.upcid != null) __params = __params.set('upcid', params.upcid.toString());
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.skuid != null) __params = __params.set('skuid', params.skuid.toString());
    if (params.sizeid != null) __params = __params.set('sizeid', params.sizeid.toString());
    if (params.flavorid != null) __params = __params.set('flavorid', params.flavorid.toString());
    if (params.distskuid != null) __params = __params.set('distskuid', params.distskuid.toString());
    if (params.dist != null) __params = __params.set('dist', params.dist.toString());
    if (params.destination != null) __params = __params.set('destination', params.destination.toString());
    if (params.brandid != null) __params = __params.set('brandid', params.brandid.toString());
    if (params.appellationid != null) __params = __params.set('appellationid', params.appellationid.toString());
    if (params.status != null) __params = __params.set('status', params.status.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/product`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * # Product service
   * Returns a list of products.
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only products the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   *
   * (Note: pageno and pagesize are required)
   * @param params The `ApiService.GetProductsParams` containing the following parameters:
   *
   * - `pagesize`: Number of products to return per page
   *
   * - `pageno`: Page number in a paged result set - pageno starts at 1
   *
   * - `upcid`: Optional filter by UPC - supports partial matches
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `skuid`: Optional filter by SKU ID (Full SKU) - supports partial matches
   *
   * - `sizeid`: Optional filter by size ID
   *
   * - `flavorid`: Optional filter by flavor ID
   *
   * - `distskuid`: Optional filter by distributor SKU ID - supports partial matches
   *
   * - `dist`: Distributor billTo id
   *
   * - `destination`: Optional filter by destination DOMESTIC or INTERNATIONAL
   *
   * - `brandid`: Optional filter by brand ID
   *
   * - `appellationid`: Optional filter by appellation ID
   */
  getProducts(params: ApiService.GetProductsParams): __Observable<null> {
    console.log('getProducts params', params);
    return this.getProductsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * # Product service
   * Returns a single product with {id}.
   *
   * Note: does not check eligibility - no sensitive info. Accepts dist param for consistency but does not use it.
   * @param params The `ApiService.GetProductParams` containing the following parameters:
   *
   * - `id`: Product id to filter (Full SKU / Material ID)
   *
   * - `dist`: Distributor billTo id
   */
  getProductResponse(params: ApiService.GetProductParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.dist != null) __params = __params.set('dist', params.dist.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/product/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * # Product service
   * Returns a single product with {id}.
   *
   * Note: does not check eligibility - no sensitive info. Accepts dist param for consistency but does not use it.
   * @param params The `ApiService.GetProductParams` containing the following parameters:
   *
   * - `id`: Product id to filter (Full SKU / Material ID)
   *
   * - `dist`: Distributor billTo id
   */
  getProduct(params: ApiService.GetProductParams): __Observable<null> {
    return this.getProductResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * # Product service - export
   * Returns a large set of attributes per product for products mathcing optional filter criteria - or all products if not filtered
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only product attributes the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   *
   * (Note: pageno and pagesize are optional to enable pagination - if pagination is desired then both are required to enable it)
   * @param params The `ApiService.GetExportListParams` containing the following parameters:
   *
   * - `upcid`: Optional filter by UPC - supports partial matches
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `skuid`: Optional filter by SKU ID (Full SKU) - supports partial matches
   *
   * - `sizeid`: Optional filter by size ID
   *
   * - `pagesize`: Number of products to return per page
   *
   * - `pageno`: Page number in a paged result set - pageno starts at 1
   *
   * - `flavorid`: Optional filter by flavor ID
   *
   * - `distskuid`: Optional filter by distributor SKU ID - supports partial matches
   *
   * - `dist`: Distributor billTo id
   *
   * - `destination`: Optional filter by destination DOMESTIC or INTERNATIONAL
   *
   * - `brandid`: Optional filter by brand ID
   *
   * - `appellationid`: Optional filter by appellation ID
   */
  getExportListResponse(params: ApiService.GetExportListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.upcid != null) __params = __params.set('upcid', params.upcid.toString());
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.skuid != null) __params = __params.set('skuid', params.skuid.toString());
    if (params.sizeid != null) __params = __params.set('sizeid', params.sizeid.toString());
    if (params.pagesize != null) __params = __params.set('pagesize', params.pagesize.toString());
    if (params.pageno != null) __params = __params.set('pageno', params.pageno.toString());
    if (params.flavorid != null) __params = __params.set('flavorid', params.flavorid.toString());
    if (params.distskuid != null) __params = __params.set('distskuid', params.distskuid.toString());
    if (params.dist != null) __params = __params.set('dist', params.dist.toString());
    if (params.destination != null) __params = __params.set('destination', params.destination.toString());
    if (params.brandid != null) __params = __params.set('brandid', params.brandid.toString());
    if (params.appellationid != null) __params = __params.set('appellationid', params.appellationid.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/exportlist`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * # Product service - export
   * Returns a large set of attributes per product for products mathcing optional filter criteria - or all products if not filtered
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only product attributes the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   *
   * (Note: pageno and pagesize are optional to enable pagination - if pagination is desired then both are required to enable it)
   * @param params The `ApiService.GetExportListParams` containing the following parameters:
   *
   * - `upcid`: Optional filter by UPC - supports partial matches
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `skuid`: Optional filter by SKU ID (Full SKU) - supports partial matches
   *
   * - `sizeid`: Optional filter by size ID
   *
   * - `pagesize`: Number of products to return per page
   *
   * - `pageno`: Page number in a paged result set - pageno starts at 1
   *
   * - `flavorid`: Optional filter by flavor ID
   *
   * - `distskuid`: Optional filter by distributor SKU ID - supports partial matches
   *
   * - `dist`: Distributor billTo id
   *
   * - `destination`: Optional filter by destination DOMESTIC or INTERNATIONAL
   *
   * - `brandid`: Optional filter by brand ID
   *
   * - `appellationid`: Optional filter by appellation ID
   */
  getExportList(params: ApiService.GetExportListParams): __Observable<null> {
    return this.getExportListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * # Product service filters
   * Returns a list of brand,flavor,size,appellation,destination combinations to use for filtering
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only product attributes the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   *
   * (Note: pageno and pagesize are required)
   * @param params The `ApiService.GetFiltersParams` containing the following parameters:
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `sizeid`: Optional filter by size ID
   *
   * - `flavorid`: Optional filter by flavor ID
   *
   * - `dist`: Distributor billTo id
   *
   * - `destination`: Optional filter by destination DOMESTIC or INTERNATIONAL
   *
   * - `brandid`: Optional filter by brand ID
   *
   * - `appellationid`: Optional filter by appellation ID
   */
  getFiltersResponse(params: ApiService.GetFiltersParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.sizeid != null) __params = __params.set('sizeid', params.sizeid.toString());
    if (params.flavorid != null) __params = __params.set('flavorid', params.flavorid.toString());
    if (params.dist != null) __params = __params.set('dist', params.dist.toString());
    if (params.destination != null) __params = __params.set('destination', params.destination.toString());
    if (params.brandid != null) __params = __params.set('brandid', params.brandid.toString());
    if (params.appellationid != null) __params = __params.set('appellationid', params.appellationid.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/filterlist`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * # Product service filters
   * Returns a list of brand,flavor,size,appellation,destination combinations to use for filtering
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only product attributes the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   *
   * (Note: pageno and pagesize are required)
   * @param params The `ApiService.GetFiltersParams` containing the following parameters:
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `sizeid`: Optional filter by size ID
   *
   * - `flavorid`: Optional filter by flavor ID
   *
   * - `dist`: Distributor billTo id
   *
   * - `destination`: Optional filter by destination DOMESTIC or INTERNATIONAL
   *
   * - `brandid`: Optional filter by brand ID
   *
   * - `appellationid`: Optional filter by appellation ID
   */
  getFilters(params: ApiService.GetFiltersParams): __Observable<null> {
    return this.getFiltersResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * # Brand list service
   * Returns a list of brands
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only brands the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   * If dist param is not passed and the userType=distributor, then the resultset will be tht unique combination of all brands assigned to all billtos the user is assigned to.
   * @param params The `ApiService.GetBrandsParams` containing the following parameters:
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `dist`: Distributor billTo id
   */
  getBrandsResponse(params: ApiService.GetBrandsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.dist != null) __params = __params.set('dist', params.dist.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/brandlist`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * # Brand list service
   * Returns a list of brands
   *
   * If optional dist URI parameter is passed and valid, the list will be filtered by eligibility to only brands the distributor is eligble for. (note: dist parameter is validated to ensure the user has access to that distributor)
   * If dist param is not passed and the userType=distributor, then the resultset will be tht unique combination of all brands assigned to all billtos the user is assigned to.
   * @param params The `ApiService.GetBrandsParams` containing the following parameters:
   *
   * - `status`: Status - either A or I for Active or Inactive
   *
   * - `dist`: Distributor billTo id
   */
  getBrands(params: ApiService.GetBrandsParams): __Observable<null> {
    return this.getBrandsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Returns server/service metrics
   */
  getPerfResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/perf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Returns server/service metrics
   */
  getPerf(): __Observable<null> {
    return this.getPerfResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Hearbeat returns status of service and ability to query Hana EDW
   */
  getHeartbeatResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/heartbeat`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Hearbeat returns status of service and ability to query Hana EDW
   */
  getHeartbeat(): __Observable<null> {
    return this.getHeartbeatResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Returns basic information about the service and server
   */
  aboutResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/about`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Returns basic information about the service and server
   */
  about(): __Observable<null> {
    return this.aboutResponse().pipe(
      __map(_r => _r.body as null)
    );
  }
}

module ApiService {

  /**
   * Parameters for getProducts
   */
  export interface GetProductsParams {

    /**
     * Number of products to return per page
     */
    pagesize: number;

    /**
     * Page number in a paged result set - pageno starts at 1
     */
    pageno: number;

    /**
     * Optional filter by UPC - supports partial matches
     */
    upcid?: string;

    /**
     * Status - either A or I for Active or Inactive
     */
    status?: 'A' | 'I';

    /**
     * Optional filter by SKU ID (Full SKU) - supports partial matches
     */
    skuid?: string;

    /**
     * Optional filter by size ID
     */
    sizeid?: string;

    /**
     * Optional filter by flavor ID
     */
    flavorid?: string;

    /**
     * Optional filter by distributor SKU ID - supports partial matches
     */
    distskuid?: string;

    /**
     * Distributor billTo id
     */
    dist?: number;

    /**
     * Optional filter by destination DOMESTIC or INTERNATIONAL
     */
    destination?: 'DOMESTIC' | 'INTERNATIONAL';

    /**
     * Optional filter by brand ID
     */
    brandid?: string;

    /**
     * Optional filter by appellation ID
     */
    appellationid?: string;
  }

  /**
   * Parameters for getProduct
   */
  export interface GetProductParams {

    /**
     * Product id to filter (Full SKU / Material ID)
     */
    id: string;

    /**
     * Distributor billTo id
     */
    dist?: number;
  }

  /**
   * Parameters for getExportList
   */
  export interface GetExportListParams {

    /**
     * Optional filter by UPC - supports partial matches
     */
    upcid?: string;

    /**
     * Status - either A or I for Active or Inactive
     */
    status?: 'A' | 'I';

    /**
     * Optional filter by SKU ID (Full SKU) - supports partial matches
     */
    skuid?: string;

    /**
     * Optional filter by size ID
     */
    sizeid?: string;

    /**
     * Number of products to return per page
     */
    pagesize?: number;

    /**
     * Page number in a paged result set - pageno starts at 1
     */
    pageno?: number;

    /**
     * Optional filter by flavor ID
     */
    flavorid?: string;

    /**
     * Optional filter by distributor SKU ID - supports partial matches
     */
    distskuid?: string;

    /**
     * Distributor billTo id
     */
    dist?: number;

    /**
     * Optional filter by destination DOMESTIC or INTERNATIONAL
     */
    destination?: 'DOMESTIC' | 'INTERNATIONAL';

    /**
     * Optional filter by brand ID
     */
    brandid?: string;

    /**
     * Optional filter by appellation ID
     */
    appellationid?: string;
  }

  /**
   * Parameters for getFilters
   */
  export interface GetFiltersParams {

    /**
     * Status - either A or I for Active or Inactive
     */
    status?: 'A' | 'I';

    /**
     * Optional filter by size ID
     */
    sizeid?: string;

    /**
     * Optional filter by flavor ID
     */
    flavorid?: string;

    /**
     * Distributor billTo id
     */
    dist?: number;

    /**
     * Optional filter by destination DOMESTIC or INTERNATIONAL
     */
    destination?: 'DOMESTIC' | 'INTERNATIONAL';

    /**
     * Optional filter by brand ID
     */
    brandid?: string;

    /**
     * Optional filter by appellation ID
     */
    appellationid?: string;
  }

  /**
   * Parameters for getBrands
   */
  export interface GetBrandsParams {

    /**
     * Status - either A or I for Active or Inactive
     */
    status?: 'A' | 'I';

    /**
     * Distributor billTo id
     */
    dist?: number;
  }
}

export { ApiService }
